/**
 * Fetches and parses the authenticated Employee's `/org/me` permissions.
 * 1. Fetch the raw response.
 * 2. Reject invalid roles or response shapes.
 * 3. Report unknown permission strings and return known permissions.
 * Continue in shared/permissions/useCurrentUserPermissions.ts.
 */
import { logMessage } from '@modernloop/shared/utils';

import ApiVerb from 'src/utils/api/ApiVerb';
import { apiGet } from 'src/utils/api';

import {
  CurrentUserPermissionsResponse,
  parseCurrentUserPermissionsResponse,
} from 'src/shared/permissions/currentUserPermissions';

/** Returns known permissions for the authenticated Employee and logs unknown strings without failing the request. */
export async function getCurrentUserPermissions(): Promise<CurrentUserPermissionsResponse> {
  const response = await apiGet<unknown>(ApiVerb.GET_CURRENT_USER_PERMISSIONS);
  const parsed = parseCurrentUserPermissionsResponse(response.data);

  if (!parsed) {
    throw new Error('Invalid current user permissions response');
  }

  if (parsed.unknownPermissions.length > 0) {
    logMessage('Unknown permission values in /org/me response', 'warning', {
      unknownPermissions: parsed.unknownPermissions,
    });
  }

  return parsed;
}
